import { render, staticRenderFns } from "./ConsolidationOrdersTableMobile.vue?vue&type=template&id=7d85df2b&scoped=true"
import script from "./ConsolidationOrdersTableMobile.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85df2b",
  null
  
)

export default component.exports